import SummaryItem from 'components/SummaryItem/SummaryItem'
import { translateManager as t } from 'services/TranslateManager'
import {
  addDaysToIsoDate,
  isoToDeliveryDate,
} from '../../../../utils/DateTimeUtils'
import { formatPrice } from '../../../../utils/utils'
import * as S from './DeliveryPromiseItem.styles'
import { SHIPPING_OPTION_FREE } from '../../../../stores/shippingStore/shipping.consts'

function DeliveryPromiseItem({
  hasAddress,
  deliveryPromise,
  deliveryDescription,
  shippingCost,
  isEligibleFreeShipping = null,
  shippingBuyOverData = null,
  currency,
}) {
  const getShippingItemText = () => {
    if (deliveryDescription) {
      return deliveryDescription
    } else {
      const deliveryBy = deliveryPromise
        ? isoToDeliveryDate(deliveryPromise.promisedArrivalDate.iso)
        : null
      return hasAddress && deliveryBy
        ? `${t.get('order.checkout.payment_summary_rows.delivery_by')} ${
            !hasAddress && deliveryPromise
              ? isoToDeliveryDate(
                  addDaysToIsoDate(deliveryPromise.promisedArrivalDate.iso, 2)
                )
              : deliveryBy
          }`
        : t.get('order.checkout.payment_summary_rows.shipping')
    }
  }

  const getShippingItemDescription = () => {
    if (
      !shippingBuyOverData ||
      (deliveryPromise &&
        deliveryPromise.shippingOptionName !== SHIPPING_OPTION_FREE)
    ) {
      return
    }

    if (isEligibleFreeShipping) {
      return (
        <S.Description>
          <S.IconContainer>
            <S.CheckIcon />
          </S.IconContainer>
          {t.get('order.checkout.payment_summary_rows.eligible_free_shipping')}
        </S.Description>
      )
    } else if (shippingBuyOverData?.buyOverPrice) {
      return (
        <S.Description>
          <S.IconContainer>
            <S.InfoIcon />
          </S.IconContainer>
          {t.get(
            'order.checkout.payment_summary_rows.eligible_free_shipping_over',
            {
              v1: formatPrice(
                Math.round(shippingBuyOverData.buyOverPrice),
                currency
              ),
            }
          )}
        </S.Description>
      )
    }
  }

  return (
    <SummaryItem
      text={getShippingItemText()}
      description={getShippingItemDescription()}
      testId="delivery-summary-item"
    >
      {shippingCost || shippingBuyOverData
        ? formatPrice(shippingCost, currency)
        : t.get('order.checkout.payment_summary_rows.free')}
    </SummaryItem>
  )
}

export default DeliveryPromiseItem
